import { useEffect, useRef, useState } from "react";
const DEFAULT_TIMING = {
    typeMsPerChar: 45,
    holdMs: 600,
    fadeMs: 700,
    blankMs: 200
};
function useAnimatedPlaceholder(strings, timing, enabled = true) {
    const resolvedTiming = {
        ...DEFAULT_TIMING,
        ...timing
    };
    const [stringIndex, setStringIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [phase, setPhase] = useState('typing');
    const [opacity, setOpacity] = useState(1);
    const timeoutRef = useRef(null);
    const activeStrings = strings?.filter((value)=>value.length > 0) ?? [];
    const currentString = activeStrings[stringIndex % activeStrings.length] ?? '';
    const displayText = 'blank' === phase ? '' : currentString.slice(0, Math.min(charIndex, currentString.length));
    useEffect(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (!enabled || 0 === activeStrings.length) {
            setStringIndex(0);
            setCharIndex(0);
            setPhase('typing');
            setOpacity(1);
            return;
        }
        if ('typing' === phase) {
            if (charIndex < currentString.length) {
                timeoutRef.current = setTimeout(()=>{
                    setCharIndex((previous)=>previous + 1);
                }, resolvedTiming.typeMsPerChar);
                return;
            }
            setPhase('hold');
            return;
        }
        if ('hold' === phase) {
            timeoutRef.current = setTimeout(()=>{
                setPhase('fade');
            }, resolvedTiming.holdMs);
            return;
        }
        if ('fade' === phase) {
            setOpacity(0);
            timeoutRef.current = setTimeout(()=>{
                setPhase('blank');
            }, resolvedTiming.fadeMs);
            return;
        }
        timeoutRef.current = setTimeout(()=>{
            setOpacity(1);
            setCharIndex(0);
            setStringIndex((previous)=>(previous + 1) % activeStrings.length);
            setPhase('typing');
        }, resolvedTiming.blankMs);
    }, [
        activeStrings.length,
        charIndex,
        currentString.length,
        enabled,
        phase,
        resolvedTiming.blankMs,
        resolvedTiming.fadeMs,
        resolvedTiming.holdMs,
        resolvedTiming.typeMsPerChar
    ]);
    useEffect(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    return {
        displayText,
        opacity,
        phase
    };
}
export { useAnimatedPlaceholder };
